<template>
  <div
    :id="id"
    ref="modal"
    class="modal fade"
    data-backdrop="static"
    :data-keyboard="noEsc"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-centered rd-modal-dialog"
      :class="size"
      role="document"
      :style="{ width: 'auto' }"
    >
      <div class="modal-content">
        <slot name="header">
          <div
            v-if="title"
            class="modal-header rd-modal-header"
          >
            <div class="container">
              <h5
                class="modal-title ml-auto"
                :class="{'mr-auto': !showCloseButton}"
              >
                {{ title }}
              </h5>
            </div>
          </div>
        </slot>
        <div class="modal-body">
          <slot>Content Here</slot>
        </div>
        <div
          v-if="hasFooter"
          class="modal-footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
    name: 'BaseModal',
    props: {
        id: {
            type: String,
            default: '',
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        showCloseButton: {
            type: Boolean,
            default: true,
        },
        show: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'modal-xl',
        },
        noEsc: {
            type: String,
            default: 'true',
        },
        /* dialogWidth: {
            type: String,
            default: '',
        }, */
    },
    computed: {
        hasFooter() {
            return !!this.$slots.footer;
        },
    },
    watch: {
        show() {
            if (this.show === true) {
                this.showModal();
            } else {
                this.close();
            }
        },
    },
    mounted() {
        if (this.show === true) {
            this.showModal();
        }
    },
    beforeDestroy() {
        this.close();
    },
    methods: {
        notificate() {
            $(this.$refs.modal).on('hidden.bs.modal', () => {
                this.$emit('closed');
                $(`#${this.id}`).attr('show', false);
            });
            $(this.$refs.modal).on('shown.bs.modal', () => {
                this.$emit('shown');
            });
        },
        close() {
            $(this.$refs.modal).modal('hide');
        },
        showModal() {
            $(`#${this.id}.modal, .modal-backdrop`).remove();
            this.notificate();
            $(this.$refs.modal).modal();
        },
    },
};
</script>
<style lang="scss">
.modal {
  -webkit-overflow-scrolling: touch;
}
.modal-dialog {
  /* margin: 0 !important; */
}

.modal-xl {
  max-width: 1024px;
}
.rd-modal-header {
  .row {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    align-items: center;
  }
  .modal-title {
    font-family: "Quicksand Medium", "Roboto", sans-serif;
    text-align: center;
    font-size: 2em;
  }
  .col-1:last-child button {
    background-color: #d8d8d8;
    width: 1.4em;
    height: 1.4em;
    border-radius: 50%;
    padding: 0;
    font-weight: lighter;
    position: absolute;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4em;
    transform: scale(80%);

    span {
      transform: translateY(-0.22em) scale(130%) translateX(0.01em);
    }
  }
}
</style>
